import { ChangeDetectorRef, Component } from '@angular/core';
import { ProgressEventService } from '../services/progress-event/progress-event.service';

@Component({
	selector: 'app-pages',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.scss'],
})
export class PageComponent {
	isLoading: boolean = false;

	constructor(private cdr: ChangeDetectorRef, private progressEvent: ProgressEventService) {}

	ngAfterViewInit() {
		this.progressEvent.loader.subscribe((res: boolean) => {
			this.isLoading = res;
			this.cdr.detectChanges();
		});
	}
}
